module.exports = __webpack_public_path__ + "img/workmanship.60f21c11.png";